import React from "react";

export default () => (
  <React.Fragment>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "The Twin Towers Hotel",
            "url": "https://hoteltwintowers.com/",
            "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
            "sameAs": [
              "https://www.facebook.com/twintower.hotel/",
              "https://www.instagram.com/hotel_twintowers/",
              "https://www.linkedin.com/in/the-twin-towers-hotel/"
            ]
          }
        )
      }}
    />
  </React.Fragment>
);
